"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const common_1 = require("@/emails/common");
exports.formSchema = zod_1.default.object({
    active: zod_1.default.boolean(),
    subject: zod_1.default
        .string()
        .trim()
        .max(100)
        .min(1, { message: 'Please enter a subject line' }),
    imageBannerUrl: zod_1.default.string().optional(),
    imageBannerLink: common_1.optionalURLSchema,
    heading: zod_1.default.string().trim().max(200).optional(),
    body: zod_1.default.string().trim().max(600).optional(),
    footer: zod_1.default.string().trim().max(200).optional()
});
